import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ProfileAluno from "./ProfileAluno/ProfileAluno";

import { useLocation } from "react-router-dom";
import VagasOxedin from "../VagasOxedin";
import ProfileCurriculum from "./ProfileCurriculum";

function EditCurriculum({ styles }) {
  const location = useLocation();
  let content = "";

  switch (location.pathname) {
    case "/dashboard/profilecurriculum": {
      content = <ProfileCurriculum />;
      break;
    }
    default: {
      content = <ProfileAluno />;
    }
  }

  return (
    <Box
      component="main"
      sx={{ ...styles, backgroundColor: "#FFFFFF", flexGrow: 1, p: 1 }}
    >
      {content}
    </Box>
  );
}

export default EditCurriculum;
